/* eslint-disable react-hooks/exhaustive-deps */
import { AddCircleOutline } from "@mui/icons-material";
import {
  Button,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Stack,
  InputAdornment,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import DateTimePicker from "components/ui/dateTimePicker";
import InputField from "components/ui/inputField";
import Select from "components/ui/select";
import useBase from "hooks/useBase";
import { FaRegTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
const customAdornment = (item, params) => (
  <>
    {params.InputProps.endAdornment}
    {(item.is_completed || item.is_rejected) && (
      <InputAdornment
        position="end"
        sx={{
          backgroundColor: "#f5f5f5",
          borderRadius: "5px",
          padding: "2px 5px",
          height: "20px",
        }}
      >
        <Typography
          variant="body2"
          fontSize={14}
          sx={{
            color: item.is_completed
              ? "#52b963"
              : item.is_rejected
              ? "#fa333e"
              : "inherit",
          }}
        >{`${
          item.is_completed ? "Final" : item.is_rejected ? "Reject" : ""
        }`}</Typography>
      </InputAdornment>
    )}
  </>
);

const Form = ({ formik }) => {
  // State for 3-dot menu
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);
  const {
    base: { projectStatuses, projectCustomerStatuses },
  } = useBase();

  // Parse string data to array when receiving from API
  useEffect(() => {
    if (
      formik?.values?.project_customer_status_info &&
      typeof formik.values.project_customer_status_info === "string"
    ) {
      try {
        const parsedData = JSON.parse(
          formik.values.project_customer_status_info
        );
        formik.setFieldValue("project_customer_status_info", parsedData);
      } catch (error) {
        console.error("Error parsing project_customer_status_info:", error);
        formik.setFieldValue("project_customer_status_info", []);
      }
    }
  }, []);

  const addStatus = () => {
    formik?.setFieldValue("project_customer_status_info", [
      ...(Array.isArray(formik?.values?.project_customer_status_info)
        ? formik?.values?.project_customer_status_info
        : []),
      {
        project_customer_status_id: "",
        duration: 0,
        is_completed: false,
        is_rejected: false,
      },
    ]);
  };

  // Ensure we always have an array for rendering
  const statusInfoArray = Array.isArray(
    formik?.values?.project_customer_status_info
  )
    ? formik?.values?.project_customer_status_info.map((item) => ({
        ...item,
        is_completed: !!item.is_completed,
        is_rejected: !!item.is_rejected,
      }))
    : [];

  // Update short_index values whenever the array changes
  useEffect(() => {
    if (
      Array.isArray(formik?.values?.project_customer_status_info) &&
      formik?.values?.project_customer_status_info.length > 0
    ) {
      const updatedArray = formik.values.project_customer_status_info.map(
        (item, index) => ({
          ...item,
          short_index: index + 1,
        })
      );

      formik.setFieldValue("project_customer_status_info", updatedArray);
    }
  }, [formik?.values?.project_customer_status_info?.length]);

  return (
    <Box
      sx={{
        height: "calc(100vh - 155px)",
        overflowY: "auto",
        pt: "7px",
        mt: "-5px",
        mx: "-20px",
        px: "20px",
      }}
    >
      <Box
        sx={{
          gap: "15px",
          display: "grid",
        }}
      >
        {" "}
        <>
          <InputField name="name" label="Project Name *" formik={formik} />
          <Select
            options={projectStatuses}
            label="Project Status"
            value={formik?.values?.project_status_id}
            onChange={(value) =>
              formik.setFieldValue("project_status_id", value)
            }
            selectProps={{ id: "id", label: "name" }}
          />
          <DateTimePicker
            name="start_date"
            label="Start Date"
            formik={formik}
          />
          <DateTimePicker name="end_date" label="End Date" formik={formik} />

          <Typography
            variant="h5"
            color={(theme) => theme.palette.primary.main}
            borderBottom="1px solid #ddd"
            pb="10px"
            m="25px 0 3px"
          >
            Project Customer Status
          </Typography>

          <Box sx={{ width: "calc(100% - 35px)" }}>
            {statusInfoArray.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  mb: "20px",
                  position: "relative",
                }}
              >
                <>
                  <Stack direction="row" alignItems="center" flex={1}>
                    <Box>
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          setMenuAnchorEl(event.currentTarget);
                          setMenuIndex(index);
                        }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      <Menu
                        anchorEl={menuAnchorEl}
                        open={menuIndex === index && Boolean(menuAnchorEl)}
                        onClose={() => {
                          setMenuAnchorEl(null);
                          setMenuIndex(null);
                        }}
                      >
                        <MenuItem
                          selected={!!item.is_completed}
                          onClick={() => {
                            const updated = statusInfoArray.map((s, i) => {
                              if (i === index) {
                                return {
                                  ...s,
                                  is_completed: !item.is_completed,
                                  is_rejected: false,
                                };
                              } else {
                                return {
                                  ...s,
                                  is_completed: false,
                                };
                              }
                            });
                            formik.setFieldValue(
                              "project_customer_status_info",
                              updated
                            );
                            setMenuAnchorEl(null);
                            setMenuIndex(null);
                          }}
                        >
                          Final
                        </MenuItem>
                        <MenuItem
                          selected={!!item.is_rejected}
                          onClick={() => {
                            const updated = statusInfoArray.map((s, i) => {
                              if (i === index) {
                                return {
                                  ...s,
                                  is_completed: false,
                                  is_rejected: !item.is_rejected,
                                };
                              } else {
                                return {
                                  ...s,
                                  is_rejected: false,
                                };
                              }
                            });
                            formik.setFieldValue(
                              "project_customer_status_info",
                              updated
                            );
                            setMenuAnchorEl(null);
                            setMenuIndex(null);
                          }}
                        >
                          Reject
                        </MenuItem>
                      </Menu>
                    </Box>
                    <Select
                      startAdornment={(params) => customAdornment(item, params)}
                      isComplex
                      label={<>Status</>}
                      options={
                        projectCustomerStatuses?.filter(
                          (status) =>
                            !statusInfoArray.some(
                              (item) =>
                                item.project_customer_status_id === status.id &&
                                item !== statusInfoArray[index]
                            )
                        ) || []
                      }
                      name={`project_customer_status_info[${index}].project_customer_status_id`}
                      formik={formik}
                      selectProps={{ id: "id", label: "name" }}
                    />
                  </Stack>

                  {!(item.is_completed || item.is_rejected) && (
                    <InputField
                      sx={{ width: "130px" }}
                      disabled={!!item.is_completed || !!item.is_rejected}
                      isComplex
                      name={`project_customer_status_info[${index}].duration`}
                      label="Duration in Hours"
                      type="number"
                      formik={formik}
                    />
                  )}
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      right: "-45px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "41px",
                      width: "41px",
                    }}
                    onClick={() => {
                      const newStatus = statusInfoArray.filter(
                        (_, i) => i !== index
                      );
                      formik.setFieldValue(
                        "project_customer_status_info",
                        newStatus
                      );
                    }}
                  >
                    <FaRegTrashAlt color="#eb5757" size={18} />
                  </IconButton>
                </>
              </Box>
            ))}
            <Button
              sx={{ width: "fit-content" }}
              variant="text"
              startIcon={<AddCircleOutline />}
              onClick={addStatus}
            >
              {statusInfoArray.length > 1 ? "Add Another" : "Add"}
            </Button>
          </Box>
        </>
      </Box>
    </Box>
  );
};

export default Form;
